import {
  Button,
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@egaranti/components";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import {
  AlignCenter,
  Calendar,
  CheckSquare,
  ChevronDown,
  Circle,
  Hash,
  PlusIcon,
  Type,
} from "lucide-react";

const FIELD_TYPES = [
  {
    value: "text",
    label: "Text",
    icon: <Type className="h-4 w-4" />,
  },
  {
    value: "number",
    label: "Number",
    icon: <Hash className="h-4 w-4" />,
  },
  {
    value: "textarea",
    label: "Textarea",
    icon: <AlignCenter className="h-4 w-4" />,
  },
  {
    value: "select",
    label: "Select",
    icon: <ChevronDown className="h-4 w-4" />,
  },
  {
    value: "radio",
    label: "Radio",
    icon: <Circle className="h-4 w-4" />,
  },
  {
    value: "checkbox",
    label: "Checkbox",
    icon: <CheckSquare className="h-4 w-4" />,
  },
  {
    value: "date",
    label: "Date",
    icon: <Calendar className="h-4 w-4" />,
  },
];

const FieldTypeSelector = ({ onSelectField }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleSelect = (fieldType) => {
    onSelectField(fieldType);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="secondaryColor"
          className="flex items-center gap-2"
        >
          <PlusIcon className="h-4 w-4" />
          {t(
            "settingsPage.productRegisterActivation.formBuilder.addField",
            "Alan Ekle",
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[250px] p-0">
        <Command>
          <CommandInput
            placeholder={t(
              "settingsPage.productRegisterActivation.formBuilder.searchFieldType",
              "Alan tipi ara...",
            )}
          />
          <CommandEmpty>
            {t(
              "settingsPage.productRegisterActivation.formBuilder.noFieldTypeFound",
              "Alan tipi bulunamadı.",
            )}
          </CommandEmpty>
          <CommandGroup>
            {FIELD_TYPES.map((type) => (
              <CommandItem
                key={type.value}
                onSelect={() => handleSelect(type.value)}
                className="flex cursor-pointer items-center gap-2"
              >
                {type.icon}
                <span>
                  {t(
                    `settingsPage.productRegisterActivation.formBuilder.fieldTypes.${type.value}`,
                    type.label,
                  )}
                </span>
              </CommandItem>
            ))}
          </CommandGroup>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default FieldTypeSelector;
